module.exports = __webpack_public_path__ + "static/img/p4_02.cbd0229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/areaHospitalLink/p4_02.png
// module id = HhU5
// module chunks = 0